/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Email/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInputWithLabelField from 'DesignSystem/TysiaInputWithLabelField/index'



/** @type {import('Simple/types.js').View} */
export default function Email({
  children,
  viewPath = "/App/Account/Content/Settings/Content/CommsEmail/Emails/Emails/Content/Email/Edit/Content/Email",
  isInvalid,
  onChange
  
}) {
let editEmailEmailValueData = fromData.useDataValue({ viewPath,
context: 'edit_email',
path: 'email',
})
let editEmailEmailIsValidData = fromData.useDataIsValid({ viewPath,
context: 'edit_email',
path: 'email',
validate: fromValidate.email,
})
let editEmailEmailChangeData = fromData.useDataChange({ viewPath,
context: 'edit_email',
path: 'email',
})
  return (<React.Fragment
>
<TysiaInputWithLabelField
  viewPath={`${viewPath}/TysiaInputWithLabelField`}
 placeholder="Enter email address"
 type="email"
 label="Email address"
 data="edit_email.email"
 validate="/Data/validate.js email"
 invalid={!editEmailEmailIsValidData}
 onChange={editEmailEmailChangeData}
 value={editEmailEmailValueData}
/>
{children}
</React.Fragment>)
}